<template>
  <div class="appraise container">
    <div class="box">
      <div class="head">
        <h2 class="title">个人章节素养考核成绩</h2>
        <el-button
          style="float: right; margin-left: 10px"
          @click="
            $router.push({
              path: '/classCourse/evaluation',
              query: { id: $route.query.id, courseId: $route.query.courseId },
            })
          "
          type="primary"
          size="small"
          round
        >
          查看
        </el-button>
        <el-button
          class="btn"
          type="primary"
          size="small"
          round
          @click="handleSubmit"
          >{{ info.syComplete ? "重评" : "完成" }}</el-button
        >
      </div>
      <el-table
        class="studnet-list"
        :data="studentList"
        height="calc(100% - 61px)"
        border
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="nickName"
          label="姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="sno" label="学号" width="180" align="center">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          :formatter="sexFormatter"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="teamName"
          label="所属团队"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.teamName || "无" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="postName"
          label="岗位"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.postName || "无" }}
          </template>
        </el-table-column>
        <el-table-column prop="score" label="成绩" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.score || "无" }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="
                scoreRow(scope.row.userId, scope.row.nickName)
              "
              type="text"
              size="small"
            >
              去评分
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <div class="foot_page">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-size="searchForm.limit"
          :current-page.sync="searchForm.page"
          :total="total"
          @current-change="pageChange"
        ></el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { studentList, completeAppraise } from "@/api/chapter";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      // searchForm: {
      //   page: 1,
      //   limit: 9,
      //   classChapterId: this.$route.query.classChapterId,
      //   query: "",
      // },
      // total: 2,
      studentList: [],
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      studentList(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.studentList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 性别
    sexFormatter(row) {
      if (row.sex == "UNKNOW") {
        return "未知";
      } else if (row.sex == "MAN") {
        return "男";
      } else {
        return "女";
      }
    },
    scoreRow(userId, nickName) {
      this.$router.push({
        path: "/courseDetail/appraise/detail",
        query: {
          ...this.$route.query,
          userId,
          nickName,
        },
      });
    },
    handleSubmit() {
      this.$confirm(`确定要完成素养评价吗？`, {
        type: "warning",
      })
        .then(() => {
          completeAppraise(this.$route.query.classChapterId).then((res) => {
            if (res.code == 0) {
              this.$message.success("本章节素养评价已完成");
              this.$emit("update");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 翻页
    // pageChange() {},
  },
};
</script>

<style lang="less" scoped>
.appraise {
  height: 100%;

  .box {
    padding: 20px 30px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: rgb(255, 255, 255);

    .head {
      overflow: hidden;

      .btn {
        float: right;
      }
    }
    ::v-deep .studnet-list {
      margin-top: 20px;
      overflow: auto;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }

    ::v-deep .foot_page {
      margin-top: 30px;
      text-align: right;

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0d79ff;
      }

      .el-pagination__total {
        float: left;
      }
    }
  }
}
</style>
